import downloadMutations from "./mutations.js";
import downloadActions from "./actions.js";
import downloadGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
           filesToBeDownloaded:{},
           downloadArray:[],
           lastDownloadBatchID:null,
           currentBatch:{key:'',value:[]},
        };
    },
    mutations: downloadMutations,
    actions: downloadActions,
    getters: downloadGetters,
};